import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState('');

  const SERVICE_ID = 'service_l2l9y65';
  const TEMPLATE_ID = 'template_1j0kd3g';
  const PUBLIC_KEY = 'cs1s4C0l3fhNhXOU_';

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs
      .sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
      .then(
        () => {
          setStatus('success');
          form.current.reset();
          setTimeout(() => setStatus(''), 5000);
        },
        () => {
          setStatus('error');
          setTimeout(() => setStatus(''), 5000);
        }
      );
  };

  return (
    <div
      name="contact"
      className="w-full min-h-screen bg-gradient-to-b from-gray-900 to-dark p-4 text-white py-16"
    >
      <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-cyan-500">
            Contact
          </p>
          <p className="py-6 text-gray-300">Submit the form below to get in touch with me</p>
        </div>

        <div className="flex justify-center items-center">
          <form
            ref={form}
            onSubmit={sendEmail}
            className="flex flex-col w-full md:w-3/5 rounded-xl border border-slate-700 bg-slate-800/40 backdrop-blur-sm p-6"
          >
            <input
              type="text"
              name="from_name"
              placeholder="Enter your name"
              required
              className="p-3 bg-slate-900/70 border border-slate-600 rounded-md text-white focus:outline-none focus:border-primary transition-colors duration-300"
            />
            <input
              type="email"
              name="from_email"
              placeholder="Enter your email"
              required
              className="my-4 p-3 bg-slate-900/70 border border-slate-600 rounded-md text-white focus:outline-none focus:border-primary transition-colors duration-300"
            />
            <textarea
              name="message"
              placeholder="Enter your message"
              rows="8"
              required
              className="p-3 bg-slate-900/70 border border-slate-600 rounded-md text-white focus:outline-none focus:border-primary transition-colors duration-300"
            ></textarea>

            <button
              type="submit"
              disabled={status === 'sending'}
              className="text-white bg-gradient-to-r from-primary to-secondary px-6 py-3 mt-6 mx-auto flex items-center rounded-md hover:scale-105 duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {status === 'sending' ? 'Sending...' : "Let's talk"}
            </button>

            {status === 'success' && (
              <p className="text-emerald-400 text-center mt-3">
                Message sent successfully. I will get back to you soon.
              </p>
            )}
            {status === 'error' && (
              <p className="text-red-400 text-center mt-3">
                Failed to send message. Please try again.
              </p>
            )}
          </form>
        </div>

        <div className="flex flex-col items-center mt-8">
          <p className="text-gray-400 mb-4">Or reach me directly via WhatsApp</p>
          <a
            href="https://wa.me/769980662"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 bg-emerald-500 hover:bg-emerald-600 text-white px-6 py-3 rounded-md hover:scale-105 duration-300 shadow-lg"
          >
            <svg
              className="w-6 h-6"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
            </svg>
            <span className="font-semibold">Chat on WhatsApp</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
